module.exports = __webpack_public_path__ + "img/26.8.TSS.bc744b55.png";